export default {
  "name": "proapp",
  "api": "https://api.proapp.proapp.fi",
  "chat_api": "https://chat-proapp.proapp.fi",
}
